const SET_SOURCE = (state, dossier) => {
  state.source = dossier
}

const SET_DOSSIER = (state, dossier) => {
  state.dossier = dossier
}

const SET_DOSSIERS = (state, dossiers) => {
  state.dossiers = dossiers
}

const SET_PROFILES = (state, profiles) => {
  state.profiles = profiles
}

const PURGE_DOSSIER = (state) => {
  state.dossier = {}
}

const SEARCH = (state, query) => {
  state.dossiers.forEach(
    (dossier) => {
      dossier.hide = !dossier.titel.toLowerCase().includes(query)
    }
  )
}

const RESET = (state) => {
  state.source = null
  state.dossier = {}
  state.dossiers = []
}

export default {
  RESET,
  SEARCH,
  SET_SOURCE,
  SET_DOSSIER,
  SET_DOSSIERS,
  SET_PROFILES,
  PURGE_DOSSIER
}
